module.exports = __webpack_public_path__ + "static/media/search.e3716937.svg";